import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import PersonIcon from "@mui/icons-material/Person";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import SearchIcon from "@mui/icons-material/Search";
import {
  Avatar,
  Divider,
  Menu,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectUser } from "store/global/authPermission/selector";
import { APP_VERSION } from "utils/constants";
import { actions as authActions } from "../../../Auth/slice";
import { useStyles } from "./styles";

type Props = {
  q?: string;
  setSearch?(q: string): void;
};

export default function TopBar({ q, setSearch }: Props) {
  const user = useSelector(selectUser);
  const styles = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const { t } = useTranslation();

  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);

  const handleLogout = () => {
    localStorage.clear();
    dispatch(authActions.logout());
    navigate("/auth/login");
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (setSearch) {
      setSearch(event.target.value);
    }
  };

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <>
      <Box className={styles.root}>
        <Box className={styles.container}>
          <Box className={styles.leftSection}>
            <Tooltip title={t("TOOLTIP.OPEN_SETTINGS")}>
              <Box className={styles.userBox} onClick={handleOpenUserMenu}>
                <KeyboardArrowDownIcon className={styles.arrowIcon} />

                <Typography className={styles.userName}>
                  {user?.firstName || "גין סנטאג"}
                </Typography>

                <Avatar src={user?.url} className={styles.avatar}>
                  {user?.firstName?.charAt(0)?.toUpperCase() || "JS"}
                </Avatar>
              </Box>
            </Tooltip>

            <Box className={styles.notificationBox}>
              <NotificationsNoneIcon className={styles.notificationIcon} />
            </Box>
          </Box>

          <Box className={styles.rightSection}>
            <TextField
              className={styles.search}
              placeholder={t("PLACEHOLDERS.SEARCH")}
              size="small"
              value={q || ""}
              onChange={handleSearchChange}
              InputProps={{
                startAdornment: <SearchIcon className={styles.searchIcon} />,
              }}
            />
          </Box>
        </Box>
      </Box>

      <Menu
        sx={{
          mt: "45px",
        }}
        PaperProps={{
          sx: {
            borderRadius: "8px",
            minWidth: "200px",
            padding: "8px 0",
          },
        }}
        MenuListProps={{
          sx: {
            padding: 0,
            direction: theme.direction,
          },
        }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        <MenuItem
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
          }}
          onClick={() => {
            navigate("/profile");
            handleCloseUserMenu();
          }}
        >
          <PersonIcon sx={{ color: "rgb(110, 117, 141)" }} />
          <Typography>{t("COMMON.PROFILE")}</Typography>
        </MenuItem>

        <Divider />

        <MenuItem
          onClick={() => {
            handleCloseUserMenu();
            handleLogout();
          }}
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography>{t("COMMON.LOG_OUT")}</Typography>
          <PowerSettingsNewIcon sx={{ color: "rgb(110, 117, 141)" }} />
        </MenuItem>

        <Divider />

        <Typography className={styles.versionInfo}>
          {t("COMMON.APP_VERSION", { version: APP_VERSION })}
        </Typography>
      </Menu>
    </>
  );
}
